export const DAILY_PRACTICES = [
  {
    id: "prayer",
    number: "01",
    title: "Prayer",
    subtitle: "Speak to G-d directly",
    body: "There is no required Noahide liturgy — which means prayer can be yours. Solomon asked that G-d hear 'the stranger who is not of Your people' (I Kings 8:41–43), and the Sages taught that G-d hears every sincere heart. Many Noahides set aside a few minutes each morning and evening: thanks for waking, requests for the day, and the Psalms, which have carried the prayers of humanity for three thousand years.",
    practices: [
      "Begin the day with a sentence of gratitude before anything else.",
      "Pray in your own words and your own language.",
      "Use Psalms — 23, 100, 121, 145 are gentle places to start.",
    ],
  },
  {
    id: "gratitude",
    number: "02",
    title: "Gratitude",
    subtitle: "Blessing what you receive",
    body: "The Hebrew word for a Jew — Yehudi — comes from the root 'to thank'. But gratitude is not a Jewish possession; it is the natural response of any creature who notices that life is a gift. Before eating, on hearing good news, on seeing something beautiful — a quiet 'thank You' trains the eye to see the Giver behind the given.",
    practices: [
      "Acknowledge G-d before meals in your own words.",
      "Keep a short daily note of three things you were given.",
      "Thank people — gratitude to others is gratitude to their Maker.",
    ],
  },
  {
    id: "family",
    number: "03",
    title: "Family & Honouring Parents",
    subtitle: "The first society",
    body: "Honouring one's father and mother is not formally one of the Seven, yet the Torah praises it in the Children of Noah: Shem and Japheth covered their father's shame and were blessed for it (Genesis 9:23). A home ordered by respect — between spouses, toward parents, with children — is the place where every other law is first learned.",
    practices: [
      "Speak to and about your parents with respect, even in disagreement.",
      "Make time for family meals without screens.",
      "Teach children why — not only what — so values become theirs.",
    ],
  },
  {
    id: "business",
    number: "04",
    title: "Honest Business",
    subtitle: "Integrity in the marketplace",
    body: "The Talmud teaches that the first question a soul is asked after life is: 'Did you deal honestly in business?' The prohibition of theft reaches into pricing, advertising, wages, contracts and the quiet temptations of expense reports and tax forms. Honest weights and honest words are a form of worship.",
    practices: [
      "Describe what you sell accurately; disclose what a buyer would want to know.",
      "Pay employees and suppliers on time.",
      "Give a full day's work for a full day's pay.",
    ],
  },
  {
    id: "kindness",
    number: "05",
    title: "Acts of Kindness",
    subtitle: "Chesed — the way of Abraham",
    body: "Abraham's tent was open on four sides. He is the Torah's model for the nations precisely because he combined faith in the One G-d with tireless hospitality and care. 'The world is built on kindness' (Psalms 89:3). Visiting the sick, comforting mourners, welcoming guests and encouraging the discouraged are open to everyone.",
    practices: [
      "Do one deliberate kindness each day that no one asked for.",
      "Visit or call someone who is ill or alone.",
      "Welcome newcomers — at work, in your neighbourhood, in your community.",
    ],
  },
  {
    id: "charity",
    number: "06",
    title: "Charity",
    subtitle: "Tzedakah — justice, not only generosity",
    body: "The Hebrew word tzedakah means 'righteousness' rather than 'charity'. Giving to those in need is not optional kindness but the just use of what G-d has entrusted to us. G-d chose Abraham, the Torah says, so that he would teach his household 'to do tzedakah and justice' (Genesis 18:19). Giving regularly, even modestly, reshapes a person.",
    practices: [
      "Set a fixed portion of income for giving; many use ten percent as a guide.",
      "Give with dignity — the highest form helps a person become self-sufficient.",
      "Support causes that uphold life, justice and the knowledge of G-d.",
    ],
  },
  {
    id: "study",
    number: "07",
    title: "Study & Reflection",
    subtitle: "Knowing what G-d asks of you",
    body: "The Talmud says that a gentile who studies the parts of Torah that apply to him is 'like a High Priest' (Sanhedrin 59a). Study need not be scholarly: reading Genesis slowly, learning the Seven Laws in depth, reflecting on the Psalms and Proverbs, and asking honest questions of a knowledgeable teacher are all study.",
    practices: [
      "Read a few verses of Scripture daily, with a good commentary.",
      "Learn the Seven Laws in depth — The Divine Code is a thorough guide.",
      "Find a teacher or community; see our Resources page.",
    ],
  },
  {
    id: "speech",
    number: "08",
    title: "Speech & Honesty",
    subtitle: "Guarding the tongue",
    body: "'Death and life are in the power of the tongue' (Proverbs 18:21). The Torah's law of blasphemy guards speech toward G-d; its wider ethic guards speech toward people. 'Do not go about as a talebearer among your people' (Leviticus 19:16), 'keep far from a false matter' (Exodus 23:7), 'guard your tongue from evil and your lips from speaking deceit' (Psalm 34:14). Gossip, even when true, and flattery, even when kind, slowly corrode a person — and a community.",
    practices: [
      "Before repeating something about someone who is absent, ask: is it true, is it necessary, is it kind?",
      "Keep your word, even in small things — be the person whose 'yes' means yes.",
      "When you must correct someone, do it privately and gently; never shame.",
    ],
  },
  {
    id: "home",
    number: "09",
    title: "Peace in the Home",
    subtitle: "Shalom bayit — where the Divine Presence dwells",
    body: "The Sages taught that when a husband and wife are worthy, the Divine Presence dwells between them (Sotah 17a). The law of forbidden relations draws the boundaries of the family; peace in the home is what fills the space inside them. It is built from small, unglamorous things — patience, apology, listening, gratitude — and it is the first classroom in which children learn whether G-d's world is kind. 'Train a child according to his way, and even when he is old he will not depart from it' (Proverbs 22:6).",
    practices: [
      "Guard a weekly block of unhurried time with your spouse, phones away.",
      "Be the first to apologise; peace matters more than being right.",
      "Praise your children specifically and often; correct them calmly and rarely in public.",
      "Make your home a place guests feel welcome — Abraham's tent was open on every side.",
    ],
  },
];
